import { TextInput } from '@bambi/component-library/src/components/inputs/TextInput/TextInput';
import React from 'react';
import type { InputAttributes } from 'react-number-format';
import { NumericFormat } from 'react-number-format';

interface FloatInputProps {
  customInput?: React.ComponentType<InputAttributes>;
  props: any;
}

export const FloatInput = React.forwardRef(
  (
    { customInput = TextInput, ...props }: FloatInputProps,
    forwardedRef: React.Ref<HTMLInputElement>
  ) => {
    return (
      <NumericFormat
        getInputRef={forwardedRef}
        customInput={customInput}
        allowNegative={false}
        decimalScale={3}
        allowLeadingZeros={false}
        {...props}
      />
    );
  }
);
